
$(function () {
    if($('.nfr-welcome-page-container').length === 0) return;

    $('.help-choose-program-btn').click(function (){
        $('#vfr-nfr-details').modal('show');
        $('#help-choose-tab').click();
        $('.header button#help-choose-tab-accordion').click();
    });

    $('.about-fundraiser-btn.nfr-btn').click(function (){
        $('#vfr-nfr-details').modal('show');
        $('#nfr-tab').click();
        $('.header button#nfr-tab-accordion').click();
    });

    $('.about-fundraiser-btn.vfr-btn').click(function (){
        $('#vfr-nfr-details').modal('show');
        $('#vfr-tab').click();
        $('.header button#vfr-tab-accordion').click();
    });

    $(document).on("focusin", e => {
        const $modal = $(e.target).closest("#vfr-nfr-details");
        if ($modal.length !== 0) return;
        $("#vfr-nfr-details").modal("hide");
    })

    $('.quotations .owl-carousel').owlCarousel({
        nav: false,
        items: 1,
        slideBy: 1,
        dotClass: 'owl-dot',
        dotsClass: 'owl-dots',
        dots: true,
        dotsEach: false,
        dotsData: false,
        dotsSpeed: false,
        dotsContainer: false,
        onInitialized: function(event) {
            $(event.target).find('.owl-dot').each(function(index) {
                $(this).attr('title', 'Slide ' + (index + 1));
            });
        }
    });


    function toggleVideoPlayback() {
        const video = $('section.intro.virtual-fundraiser video:visible').get(0);
        if (!video) return;
        if($('#fundraiser-intro-video-btn').hasClass('play')){
            video.play();
        }else{
            video.pause();
        }
    }
    $('#fundraiser-intro-video-btn').click(function(){
        $(this).toggleClass('play');
        toggleVideoPlayback()
    })



    function loadVideo() {
        $('#fundraiser-intro-video, #fundraiser-intro-video-mobile').each(function() {
            this.pause && this.pause();
        });

        if($(window).width() <= 768){
            $('#fundraiser-intro-video-mobile').show()
            $('#fundraiser-intro-video').hide()
        }else {
            $('#fundraiser-intro-video').show()
            $('#fundraiser-intro-video-mobile').hide()

        }

        toggleVideoPlayback();
    }

    $(window).resize(function() {
        loadVideo();
    })

    loadVideo();



    $('[data-toggle="tooltip"]').tooltip();
    $('.prm-modal-close').on('click', function (e) {
        $(e.target.parentElement.parentElement).modal("hide");
    });

    $('.get-started-gtm-btn').click(function(){
        addTagManager({
            event:'get-started',
            action:'visit',
            category:'account',
            label:'nfr-vfr'
        });
    })
    $('.get-started-gtm-nfr-btn').click(function(){
        addTagManager({
            event:'get-started',
            action:'visit',
            category:'account',
            label:'nfr'
        });
    })
    $('.get-started-gtm-vfr-btn').click(function(){
        addTagManager({
            event:'get-started',
            action:'visit',
            category:'account',
            label:'vfr'
        });
    });

    setCookie('X-PROGRAM', 'fundraiser', 365);
    $('.mob-menu-overlay nav a[href="/faq"]').attr('href','/faq?program=fundraiser');

    $('.view-data-calculation-btn').click(function () {
        $('.data-calculation-modal').modal('show');
    });
});